<header class="glass-header flex items-center justify-between px-6 py-3 h-16 rounded-2xl z-150 relative">
  <!-- Left side -->
  <div class="flex items-center gap-4">
    <button
      class="icon-btn flex items-center justify-center w-10 h-10 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all duration-200 cursor-pointer"
      (click)="toggleSidebar()"
      [title]="isSidebarCollapsed ? 'Sidebar einblenden' : 'Sidebar ausblenden'"
    >
      <span class="material-icons text-xl transition-transform duration-200" [class.rotate-180]="isSidebarCollapsed">menu</span>
    </button>
  </div>
  <div class="flex items-center gap-4">
    @if (pageTitle) {
      <p class="text-xl font-semibold m-auto text-text-primary">{{ pageTitle }}</p>
    }
  </div>
  <!-- Right side - Notifications & User menu -->
  <div class="flex items-center gap-3">
    <!-- Notifications -->
    <div class="relative">
      <button
        class="icon-btn relative flex items-center justify-center w-10 h-10 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all duration-200 cursor-pointer"
        (click)="toggleNotificationMenu()"
        title="Benachrichtigungen"
      >
        <span class="material-icons text-xl">notifications</span>
        @if (unreadCount > 0) {
          <span class="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs font-bold rounded-full flex items-center justify-center">
            {{ unreadCount > 9 ? '9+' : unreadCount }}
          </span>
        }
      </button>

      <!-- Notification backdrop -->
      @if (isNotificationMenuOpen) {
        <div class="fixed inset-0 z-99" (click)="closeNotificationMenu()"></div>
      }

      <!-- Notification dropdown -->
      @if (isNotificationMenuOpen) {
        <div class="notification-dropdown absolute right-0 mt-2 w-80 rounded-2xl py-2 z-100 max-h-96 overflow-y-auto">
          <div class="flex items-center justify-between px-4 py-2 border-b border-white/10">
            <span class="font-semibold text-sm text-text-primary">Benachrichtigungen</span>
          </div>

          @if (notifications.length === 0) {
            <div class="px-4 py-8 text-center text-text-muted text-sm">Keine Benachrichtigungen</div>
          } @else {
            <div class="flex flex-col gap-1 py-1">
              @for (notification of notifications; track notification.id) {
                <div
                  class="flex items-start gap-3 mx-2 px-3 py-3 rounded-lg hover:bg-white/5 transition-colors cursor-pointer"
                  [class.bg-white/5]="!notification.read"
                  (click)="onNotificationClick(notification)"
                >
                  <span class="material-icons text-lg mt-0.5" [ngClass]="getNotificationIconClass(notification.type)">
                    {{ getNotificationIcon(notification.type) }}
                  </span>
                  <div class="flex-1 min-w-0">
                    <p class="text-sm font-medium text-text-primary truncate">{{ notification.title }}</p>
                    <p class="text-xs text-text-muted truncate">{{ notification.message }}</p>
                    <p class="text-xs text-text-muted mt-1">{{ formatNotificationTime(notification.timestamp) }}</p>
                  </div>
                  @if (!notification.read) {
                    <span class="w-2 h-2 bg-primary rounded-full mt-2"></span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>

    <!-- User menu -->
    <div class="relative ml-2">
      <button class="h-9 rounded-full flex items-center justify-center cursor-pointer" (click)="toggleUserMenu()">
        <div class="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center mr-2">
          <span class="material-icons icon">account_circle</span>
        </div>
        <span class="font-semibold text-sm text-white">{{ currentUser?.firstname }} {{ currentUser?.lastname }}</span>
        <span class="material-icons ml-1 text-gray-500">arrow_drop_down</span>
      </button>

      <!-- User menu backdrop -->
      @if (isUserMenuOpen) {
        <div class="fixed inset-0 z-99" (click)="closeUserMenu()"></div>
      }

      <!-- Dropdown menu -->
      @if (isUserMenuOpen) {
        <div class="notification-dropdown absolute right-0 mt-2 w-52 rounded-2xl py-2 z-100">
          <a
            class="flex items-center gap-3 mx-2 px-3 py-2.5 rounded-lg text-sm text-red-400 hover:text-red-300 hover:bg-white/10 transition-colors cursor-pointer"
            (click)="logout()"
          >
            <span class="material-icons text-lg">logout</span>
            Logout
          </a>
        </div>
      }
    </div>
  </div>
</header>
